import React from 'react';
import {
  GiCrossbow,
  GiCrossedSwords,
  GiSharpShuriken,
  GiBoneKnife,
  GiDaggers,
  GiGreatWarTank,
  GiKusarigama,
  GiBoomerang,
  GiBrokenShield,
  GiBrokenPottery,
  GiCheckedShield,
  GiCrackedShield,
  GiBoltShield,
  GiBroadDagger,
  GiFireShield,
  GiRoundShield,
  GiRopeCoil,
  GiWaltherPpk,
  GiAk47,
  GiGrenade,
  GiFlashGrenade,
  GiSpikedBat,
  GiSpikedMace,
  GiWhip,
  GiKatana,
  GiSpearHook,
  GiSpears,
  GiWarAxe,
  GiWarPick,
  GiVillage,
  GiWoodPile,
  GiWaterSplash,
  GiThunderSkull,
  GiTentaclesSkull,
  GiBindle,
  GiAirBalloon,
  GiAmbulance,
  GiCanoe,
  GiCavalry,
  GiZeppelin,
  GiRaceCar,
  GiRock,
  GiPowerLightning,
  GiPeaks,
  GiMiteAlt,
  GiPolarBear,
  GiPlantsAndAnimals,
  GiGhost,
  GiGecko,
  GiSnail,
  GiScallop,
  GiDeer,
  GiRam,
  GiBison,
  GiCamel,
  GiCigale,
  GiBoarEnsign,
  GiArmadillo,
  GiCobra,
  GiSpottedBug,
  GiSeaCreature,
  GiPig,
  GiWyvern,
  GiWolfHead,
  GiVulture,
  GiLion,
  GiCrown,
  GiCrownedHeart,
  GiCrownedSkull,
  GiIsland,
  GiForest,
  GiCauldron,
  GiApothecary,
  GiAmphora,
  GiBarrel,
  GiBerriesBowl,
  GiOpenChest,
  GiMushroomGills,
  GiFlail,
  GiKeyring,
  GiFlame,
  GiFireBottle,
  GiFireSilhouette,
  GiWhirlwind,
  GiSparkles,
  GiSpectre,
  GiSnowing,
  GiSnowflake2,
  GiFluffyCloud,
  GiFluffyTrefoil,
  GiPointyHat,
  GiCutDiamond,
  GiFlyingFlag,
  GiSailboat,
  GiSwamp,
  GiHighGrass,
  GiTopaz,
  GiAmethyst,
  GiPentacle,
  GiPegasus,
  GiCaduceus,
  GiWerewolf,
  GiTargetArrows,
  GiSwordsEmblem,
  GiWarlockEye,
  GiCyberEye,
  GiWhiteBook,
  GiBookshelf,
  GiTiedScroll,
  GiDeathJuice,
  GiMedicalPackAlt,
  GiHealthPotion,
  GiHealthDecrease,
  GiHealthIncrease,
  GiHealthNormal,
  GiBurningSkull,
  GiAncientRuins,
  GiByzantinTemple,
  GiCampingTent,
  GiChurch,
  GiAncientSword,
  GiCastle,
  GiColiseum,
  GiMeat,
  GiFallingLeaf,
  GiFriedFish,
  GiWrappedSweet,
  GiAlgae,
  GiBamboo,
  GiChiliPepper,
  GiWheat,
  GiNanoBot,
  GiBrutalHelm,
  GiShirt,
  GiChainMail,
  GiArmorDowngrade,
  GiArmorUpgrade,
  GiAstronautHelmet,
  GiCrestedHelmet,
  Gi3DMeeple,
  GiArchitectMask,
  GiCurlyMask,
  GiDoubleFaceMask,
  GiElfHelmet,
  GiSamuraiHelmet,
  GiSpartanHelmet,
  GiVisoredHelm,
  GiCrackedHelm,
  GiDwarfHelmet,
  GiStahlhelm,
  GiSwordman,
  GiAcrobatic,
  GiStrong,
  GiMuscleUp,
  GiHoodedFigure,
  GiRunningNinja,
  GiRevolt,
  GiTabiBoot,
  GiSlipknot,
  GiSewingNeedle,
  GiAcousticMegaphone,
  GiAlarmClock,
  GiAnarchy,
  GiPuppet,
  GiBodyBalance,
  GiBriefcase,
  GiSettingsKnobs,
  GiBinoculars,
  GiCaptainHatProfile,
  GiCaravan,
  GiCherry,
  GiCoffeeCup,
  GiCroissant,
  GiCycling,
  GiDatabase,
  GiDirectionSigns,
  GiHangingSign,
  GiDolmen,
  GiDreamCatcher,
  GiFossil,
  GiDinosaurBones,
  GiFootprint,
  GiDrakkar,
  GiBus,
  GiDiplodocus,
  GiDiploma,
  GiDolphin,
  GiSextant,
  GiChickenOven,
  GiDiamondRing,
  GiDaggerRose,
  GiDna1,
  GiDna2,
  GiDungeonGate,
  GiDigitalTrace,
  GiCancel,
  GiEarthAmerica,
  GiFastBackwardButton,
  GiFastForwardButton,
  GiFilmStrip,
  GiGClef,
  GiGreatPyramid,
  GiGreekTemple,
  GiHelp,
  GiHouse,
  GiHighKick,
  GiHorseHead,
  GiModernCity,
  GiMoneyStack,
  GiPin,
  GiPirateHat,
  GiPositionMarker,
  GiPresent,
  GiTwoCoins,
  GiUpgrade,
  GiPerson,
  GiThreeFriends,
  GiDaisy,
  GiPineTree,
  GiLinkedRings,
  GiHills,
  GiDesert,
  GiMonumentValley,
  GiCaveEntrance,
  GiVolcano,
  GiWhiteTower,
  GiHut,
  GiFactory,
  GiBigWave,
  GiThermometerCold,
  GiThermometerHot,
  GiNotebook,
  GiStabbedNote,
  GiBookAura,
  GiBookCover,
  GiBubblingFlask,
  Gi3DHammer,
  GiAbdominalArmor,
  GiAbstract001,
  GiAbstract002,
  GiAbstract003,
  GiAbstract005,
  GiAbstract007,
  GiAbstract008,
  GiAbstract009,
  GiAbstract010,
  GiAbstract011,
  GiAbstract012,
  GiAbstract013,
  GiAbstract014,
  GiAbstract016,
  GiAbstract017,
  GiAbstract018,
  GiAbstract019,
  GiAbstract020,
  GiAbstract021,
  GiAbstract022,
  GiAbstract023,
  GiAbstract024,
  GiAbstract025,
  GiAbstract026,
  GiAbstract027,
  GiAbstract028,
  GiAbstract029,
  GiAbstract030,
  GiAbstract031,
  GiAbstract032,
  GiAbstract033,
  GiAbstract034,
  GiAbstract035,
  GiAbstract036,
  GiAbstract037,
  GiAchievement,
  GiAlliedStar,
  GiSevenPointedStar,
  GiAmmoniteFossil,
  GiFlatPawPrint,
  GiFoxHead,
  GiFox,
  GiFrog,
  GiFrogPrince,
  GiGearHammer,
  GiGavel,
  GiGalleon,
  GiGemNecklace,
  GiGemChain,
  GiGemPendant,
  GiShatteredGlass,
  GiGems,
  GiGlobe,
  GiGlassHeart,
  GiGrimReaper,
  GiGunRose,
  GiShutRose,
  GiHalfHeart,
  GiHeartBottle,
  GiHeartMinus,
  GiHeartPlus,
  GiHeartShield,
  GiHeartWings,
  GiShatteredHeart,
  GiHawkEmblem,
  GiHealingShield,
  GiHourglass,
  GiExtraTime,
  GiSandsOfTime,
  GiTimeDynamite,
  GiHealing,
  GiHeartBeats,
  GiHeartDrop,
  GiSightDisabled,
  GiSkullCrack,
  GiHeavyHelm,
  GiHighShot,
  GiTwoHandedSword,
  GiBroadsword,
  GiMagnifyingGlass,
  GiMaterialsScience,
  GiMoon,
  GiMoonOrbit,
  GiOpenFolder,
  GiOpenBook,
  GiPadlock,
  GiPadlockOpen,
  GiPencil,
  GiPencilBrush,
  GiQuillInk,
  GiDiceSixFacesOne,
  GiDiceSixFacesSix,
  GiDiceEightFacesEight,
  GiDiceTwentyFacesOne,
  GiDiceTwentyFacesTwenty,
  GiD4,
  GiD10,
  GiD12,
  GiDiceShield,
  GiDiceFire,
  GiDiceTarget,
  GiRollingDices,
  GiRollingDiceCup,
  GiPerspectiveDiceSixFacesRandom,
  GiCardAceSpades,
  GiCardKingHearts,
  GiPokerHand,
  GiEmptyChessboard,
  GiChessPawn,
  GiMeeple,
  GiToken,
  GiDominoTiles,
  GiOwl,
  GiShinyApple,
  GiRingingBell,
  GiBookmark,
  GiShare,
  GiCloudUpload,
  GiCloudDownload,
  GiPriceTag,
  GiFullFolder,
  GiTrashCan,
  GiHand,
  GiHandGrip,
  GiShakingHands,
  GiHandOk,
  GiGlowingHands,
  GiMusicalNotes,
  GiGuitar,
  GiGrandPiano,
  GiViolin,
  GiDrumKit,
  GiTrumpet,
  GiSaxophone,
  GiFlute,
  GiUfo,
  GiSpaceship,
  GiRocketFlight,
  GiRingedPlanet,
  GiAlienSkull,
  GiCyborgFace,
  GiRobotHelmet,
  GiLaserGun,
  GiRayGun,
  GiBlaster,
  GiRadarDish,
  GiCircuitry,
  GiSatelliteCommunication,
  GiAtom,
} from 'react-icons/gi';

const slugifyIconLabel = label => {
  if (!label) {
    return '';
  }
  return label
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

const buildRawIconList = (size, color) => {
  const icons = [
    {
      label: 'Bundle',
      tag: 'all,travel,bundle,',
      icon: (
        <GiBindle
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Rider',
      tag: 'all,animal, people, travel,rider,horse,',
      icon: (
        <GiCavalry
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cycling',
      tag: 'all, people, travel,cycle,bike,',
      icon: (
        <GiCycling
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Canoe',
      tag: 'all,travel, vehicle, boat,canoe,',
      icon: (
        <GiCanoe
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Boat',
      tag: 'all,travel, vehicle, boat,',
      icon: (
        <GiSailboat
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Galleon',
      tag: 'all,travel, vehicle, boat,galleon,',
      icon: (
        <GiGalleon
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Drakkar',
      tag: 'all,travel, vehicle, boat,drakkar,viking,',
      icon: (
        <GiDrakkar
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hot air balloon',
      tag: 'all,travel, vehicle, fly,hot,air,balloon,',
      icon: (
        <GiAirBalloon
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sextant',
      tag: 'all,travel,navigation,sextant',
      icon: (
        <GiSextant
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Zeppelin',
      tag: 'all,travel, vehicle, fly,zeppelin,',
      icon: (
        <GiZeppelin
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Car',
      tag: 'all,travel, vehicle, car,',
      icon: (
        <GiRaceCar
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Bus',
      tag: 'all,travel, vehicle, car,bus,',
      icon: (
        <GiBus
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Caravan',
      tag: 'all,travel, vehicle, car,caravan,',
      icon: (
        <GiCaravan
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ambulance',
      tag: 'all,travel, vehicle, car,ambulance,',
      icon: (
        <GiAmbulance
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'UFO',
      tag: 'all,sci-fi,science fiction,ufo,alien,space,ship,vehicle,travel,',
      icon: (
        <GiUfo
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Spaceship',
      tag: 'all,sci-fi,science fiction,spaceship,ship,space,vehicle,travel,',
      icon: (
        <GiSpaceship
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Rocket',
      tag: 'all,sci-fi,science fiction,rocket,space,launch,vehicle,travel,',
      icon: (
        <GiRocketFlight
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Satellite',
      tag: 'all,sci-fi,science fiction,satellite,communication,space,travel,navigation,',
      icon: (
        <GiSatelliteCommunication
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Radar dish',
      tag: 'all,sci-fi,science fiction,radar,dish,scan,signal,navigation,travel,',
      icon: (
        <GiRadarDish
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Spider',
      tag: 'all,animal, insect, spider,nature,',
      icon: (
        <GiMiteAlt
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cicada',
      tag: 'all,animal, insect, cicada,nature,',
      icon: (
        <GiCigale
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ladybug',
      tag: 'all,animal, insect, ladybug,nature,',
      icon: (
        <GiSpottedBug
          size={size}
          color={color}
        />
      ),
    },

    {
      label: 'Bear',
      tag: 'all,animal, carnivorous, mammal, bear,nature,',
      icon: (
        <GiPolarBear
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ram',
      tag: 'all,animal, mammal, ram, aries,nature,',
      icon: (
        <GiRam
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Bison',
      tag: 'all,animal, mammal, bison,nature,',
      icon: (
        <GiBison
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Owl',
      tag: 'all,animal, bird, owl,nature,',
      icon: (
        <GiOwl
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Camel',
      tag: 'all,animal, mammal, camel,nature,',
      icon: (
        <GiCamel
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Deer',
      tag: 'all,animal, mammal, deer,nature,forest',
      icon: (
        <GiDeer
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Horse head',
      tag: 'all,animal, mammal, horse, head,nature,',
      icon: (
        <GiHorseHead
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Boar',
      tag: 'all,animal, mammal, boar,emblem, badge, symbol,nature,',
      icon: (
        <GiBoarEnsign
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fox',
      tag: 'all,animal, mammal, fox, symbol,nature,',
      icon: (
        <GiFox
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pig',
      tag: 'all,animal, mammal, pig,nature,',
      icon: (
        <GiPig
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Frog',
      tag: 'all,animal, mammal, frog,nature,',
      icon: (
        <GiFrog
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Frog crown',
      tag: 'all,animal, mammal, frog,nature, crown,',
      icon: (
        <GiFrogPrince
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Armadillo',
      tag: 'all,animal, mammal, armadillo,nature,',
      icon: (
        <GiArmadillo
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cobra',
      tag: 'all,animal, carnivorous, snake, reptile, cobra,nature,',
      icon: (
        <GiCobra
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gecko',
      tag: 'all,animal,reptile,lizard,gecko,nature',
      icon: (
        <GiGecko
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crow',
      tag: 'all,animal, carnivorous, raven, crow,nature,',
      icon: (
        <GiVulture
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sea serpent',
      tag: 'all,animal, carnivorous, snake, reptile,monster,',
      icon: (
        <GiSeaCreature
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Snail',
      tag: 'all,animal, snail,slow,nature',
      icon: (
        <GiSnail
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dragon',
      tag: 'all,animal, carnivorous, reptile, dragon,monster,',
      icon: (
        <GiWyvern
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Wolf',
      tag: 'all,animal, carnivorous, mammal, wolf,emblem, badge, symbol,head,nature,',
      icon: (
        <GiWolfHead
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fox head',
      tag: 'all,animal, carnivorous, mammal, fox,emblem, badge, symbol,head,nature,',
      icon: (
        <GiFoxHead
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Lion',
      tag: 'all,animal, carnivorous, mammal, lion,emblem, badge, symbol,head,nature,',
      icon: (
        <GiLion
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dinosaur',
      tag: 'all,animal,nature,dinosaur,diplodocus,',
      icon: (
        <GiDiplodocus
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ammonite Fossil',
      tag: 'all,animal,nature,dinosaur,ammonite, fossil,',
      icon: (
        <GiAmmoniteFossil
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dinosaur bones',
      tag: 'all,animal,nature,dinosaur,bones,fossil',
      icon: (
        <GiDinosaurBones
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dolphin',
      tag: 'all,animal, dolphin, mammal, water,sea, ocean,nature,',
      icon: (
        <GiDolphin
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Scallop',
      tag: 'all,animal,scallop,shell,sea',
      icon: (
        <GiScallop
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Fish',
      tag: 'all,food, animal, fish,nature,',
      icon: (
        <GiFriedFish
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Meat',
      tag: 'all,food, meat,nature,',
      icon: (
        <GiMeat
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sweet',
      tag: 'all,food, sweet,',
      icon: (
        <GiWrappedSweet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pine',
      tag: 'all,tree, pine, vegetal,nature,plant,',
      icon: (
        <GiPineTree
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Leaf',
      tag: 'all,food, leaf, tree, vegetal,nature,plant,',
      icon: (
        <GiFallingLeaf
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Wood',
      tag: 'all,food, wood, tree, vegetal,nature,plant,',
      icon: (
        <GiWoodPile
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Seaweed',
      tag: 'all,food, water, vegetal, sea, ocean, seaweed,nature,algae,plant,',
      icon: (
        <GiAlgae
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Bamboo',
      tag: 'all,food, tree, bamboo, vegetal,nature,plant,',
      icon: (
        <GiBamboo
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Flower',
      tag: 'all,flower, plant, vegetal,nature,plant,',
      icon: (
        <GiDaisy
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cereals',
      tag: 'all,food, cereal, wheat, vegetal,nature,plant,',
      icon: (
        <GiWheat
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Chili pepper',
      tag: 'all,food, spicy, chili pepper, vegetal,nature,plant,',
      icon: (
        <GiChiliPepper
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Mushroom',
      tag: 'all,food, mushroom, vegetal,nature,plant,',
      icon: (
        <GiMushroomGills
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cherry',
      tag: 'all,food, cherry,fruit, vegetal,nature,plant,',
      icon: (
        <GiCherry
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Chicken',
      tag: 'all,food, chicken, meat,cooked,',
      icon: (
        <GiChickenOven
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Coffee cup',
      tag: 'all,food, drink, coffee, cup, hot,',
      icon: (
        <GiCoffeeCup
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Croissant',
      tag: 'all,food, croissant, pastry, cooked,',
      icon: (
        <GiCroissant
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Horn helmet',
      tag: 'all,cloth, hat, head, helmet,horn,',
      icon: (
        <GiBrutalHelm
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heavy helmet',
      tag: 'all,cloth, hat, head, helmet,',
      icon: (
        <GiHeavyHelm
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pointed hat',
      tag: 'all,cloth, hat, head, witch,pointed,',
      icon: (
        <GiPointyHat
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crown',
      tag: 'all,cloth, hat, head, crown,jewel,',
      icon: (
        <GiCrown
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Captain hat',
      tag: 'all,cloth, hat, head, captain,',
      icon: (
        <GiCaptainHatProfile
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pirate hat',
      tag: 'all,cloth, hat, head, pirate,',
      icon: (
        <GiPirateHat
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Top',
      tag: 'all,cloth, top,',
      icon: (
        <GiShirt
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Chainmail',
      tag: 'all,cloth, chainmail,',
      icon: (
        <GiChainMail
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Armor upgrade',
      tag: 'all,cloth,armor,upgrade,defense,positive',
      icon: (
        <GiArmorUpgrade
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Armor downgrade',
      tag: 'all,cloth,armor,downgrade,defense,negative',
      icon: (
        <GiArmorDowngrade
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Astronaut helmet',
      tag: 'all,helmet,space,astronaut,gear',
      icon: (
        <GiAstronautHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Robot helmet',
      tag: 'all,sci-fi,science fiction,technology,robot,android,helmet,cyber,cloth,armor,',
      icon: (
        <GiRobotHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crested helmet',
      tag: 'all,helmet,crest,roman',
      icon: (
        <GiCrestedHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Elf helmet',
      tag: 'all,helmet,elf,light',
      icon: (
        <GiElfHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Samurai helmet',
      tag: 'all,helmet,samurai,armor',
      icon: (
        <GiSamuraiHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Spartan helmet',
      tag: 'all,helmet,spartan,armor',
      icon: (
        <GiSpartanHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Visored helm',
      tag: 'all,helmet,visored,heavy',
      icon: (
        <GiVisoredHelm
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cracked helm',
      tag: 'all,helmet,cracked,broken',
      icon: (
        <GiCrackedHelm
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dwarf helmet',
      tag: 'all,helmet,dwarf,heavy',
      icon: (
        <GiDwarfHelmet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Stahlhelm',
      tag: 'all,helmet,stahlhelm,war',
      icon: (
        <GiStahlhelm
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abdominal armor',
      tag: 'all,cloth, armor,',
      icon: (
        <GiAbdominalArmor
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Boot',
      tag: 'all,cloth, boot,',
      icon: (
        <GiTabiBoot
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Diamond ring',
      tag: 'all,cloth, diamond,ring,jewel,',
      icon: (
        <GiDiamondRing
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gem chain',
      tag: 'all,cloth, diamond,necklace,chain gem,jewel,',
      icon: (
        <GiGemChain
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gem necklace',
      tag: 'all,cloth, diamond,necklace, gem,jewel,',
      icon: (
        <GiGemNecklace
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gem pendant',
      tag: 'all,cloth, diamond,necklace,pendant gem,jewel,',
      icon: (
        <GiGemPendant
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Shattered glass',
      tag: 'all,glass,broken,shattered,object',
      icon: (
        <GiShatteredGlass
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Marionette',
      tag: 'all,puppet,control,strings',
      icon: (
        <GiPuppet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sewing needle',
      tag: 'all,tool,sewing,needle,craft',
      icon: (
        <GiSewingNeedle
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Slipknot',
      tag: 'all,tool,knot,rope',
      icon: (
        <GiSlipknot
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Binoculars',
      tag: 'all,tool,binoculars,vision,scout',
      icon: (
        <GiBinoculars
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Bow',
      tag: 'all,weapon, bow, arrow,',
      icon: (
        <GiHighShot
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crossbow',
      tag: 'all,weapon, crossbow, arrow,',
      icon: (
        <GiCrossbow
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Harpoon spear',
      tag: 'all,weapon, spear, hook, polearm',
      icon: (
        <GiSpearHook
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Twin spears',
      tag: 'all,weapon, spears, polearm',
      icon: (
        <GiSpears
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sword',
      tag: 'all,weapon, sword,',
      icon: (
        <GiBroadsword
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Two handed sword',
      tag: 'all,weapon, sword, two, handed,',
      icon: (
        <GiTwoHandedSword
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crossed swords',
      tag: 'all,weapon, sword, crossed, duel, battle,',
      icon: (
        <GiCrossedSwords
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Strong arm',
      tag: 'all,body,strong,strength,bonus',
      icon: (
        <GiStrong
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Muscle up',
      tag: 'all,body,muscle,strength,workout',
      icon: (
        <GiMuscleUp
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Shuriken',
      tag: 'all,weapon, shuriken,',
      icon: (
        <GiSharpShuriken
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Knife',
      tag: 'all,weapon, knife,',
      icon: (
        <GiBoneKnife
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Broad dagger',
      tag: 'all,weapon, dagger, blade',
      icon: (
        <GiBroadDagger
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Twin daggers',
      tag: 'all,weapon, daggers, blade, rogue',
      icon: (
        <GiDaggers
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'War axe',
      tag: 'all,weapon, axe,',
      icon: (
        <GiWarAxe
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Katana',
      tag: 'all,weapon, sword, katana, samurai',
      icon: (
        <GiKatana
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Scourge',
      tag: 'all,weapon, scourge,',
      icon: (
        <GiFlail
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Rope coil',
      tag: 'all,tool, rope, knot, climb',
      icon: (
        <GiRopeCoil
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Kusarigama',
      tag: 'all,weapon, kusarigama,',
      icon: (
        <GiKusarigama
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hammer',
      tag: 'all,weapon, hammer,',
      icon: (
        <GiGavel
          size={size}
          color={color}
        />
      ),
    },
    {
      label: '3d Hammer',
      tag: 'all,weapon, hammer,',
      icon: (
        <Gi3DHammer
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Boomerang',
      tag: 'all,weapon, boomerang,',
      icon: (
        <GiBoomerang
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Broken shield',
      tag: 'all,weapon,shield,broken,damage,defense',
      icon: (
        <GiBrokenShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Checked shield',
      tag: 'all,weapon,shield,pattern,checkered,defense',
      icon: (
        <GiCheckedShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cracked shield',
      tag: 'all,weapon,shield,cracked,damage,defense',
      icon: (
        <GiCrackedShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Bolt shield',
      tag: 'all,weapon,shield,lightning,defense,protection',
      icon: (
        <GiBoltShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fire shield',
      tag: 'all,weapon,shield,fire,magic,defense',
      icon: (
        <GiFireShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Whip',
      tag: 'all,weapon, whip,',
      icon: (
        <GiWhip
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Round shield',
      tag: 'all,weapon, shield,',
      icon: (
        <GiRoundShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Bat',
      tag: 'all,weapon, bat,',
      icon: (
        <GiSpikedBat
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Spiked mace',
      tag: 'all,weapon, mace, spiked,',
      icon: (
        <GiSpikedMace
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pickaxe',
      tag: 'all,weapon, pickaxe,',
      icon: (
        <GiWarPick
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gun',
      tag: 'all,weapon, gun,',
      icon: (
        <GiWaltherPpk
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'AK-47',
      tag: 'all,weapon, gun, rifle, ak47, assault,',
      icon: (
        <GiAk47
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Laser gun',
      tag: 'all,sci-fi,science fiction,laser,gun,weapon,blaster,',
      icon: (
        <GiLaserGun
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ray gun',
      tag: 'all,sci-fi,science fiction,ray gun,weapon,blaster,laser,',
      icon: (
        <GiRayGun
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Blaster',
      tag: 'all,sci-fi,science fiction,blaster,weapon,gun,laser,',
      icon: (
        <GiBlaster
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Grenade',
      tag: 'all,weapon, explosive, grenade,',
      icon: (
        <GiGrenade
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Flash grenade',
      tag: 'all,weapon, explosive, grenade, flashbang, stun,',
      icon: (
        <GiFlashGrenade
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Tank',
      tag: 'all,weapon, vehicle, tank,',
      icon: (
        <GiGreatWarTank
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Apothecary',
      tag: 'all,apothecary,cooked, potion, witch,',
      icon: (
        <GiApothecary
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fruit basket',
      tag: 'all,basket,food, fruit, vegetal, nature,',
      icon: (
        <GiBerriesBowl
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Shiny apple',
      tag: 'all,food,fruit,apple,shiny',
      icon: (
        <GiShinyApple
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cauldron',
      tag: 'all,cauldron,food, cooked, potion, witch,',
      icon: (
        <GiCauldron
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'BubblingFlask',
      tag: 'all,flask,food, cooked, potion, witch,',
      icon: (
        <GiBubblingFlask
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Amphora',
      tag: 'all,amphora,box, wine, food,',
      icon: (
        <GiAmphora
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Broken pottery',
      tag: 'all,pottery,broke,ceramic,artifact',
      icon: (
        <GiBrokenPottery
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Barrel',
      tag: 'all,barrel,box',
      icon: (
        <GiBarrel
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Briefcase',
      tag: 'all,briefcase,bag',
      icon: (
        <GiBriefcase
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Chest',
      tag: 'all,chest,fortune, box, protection, locked,',
      icon: (
        <GiOpenChest
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Fire',
      tag: 'all,fire,element, nature, force, hot, flame,',
      icon: (
        <GiFlame
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fire bottle',
      tag: 'all,weapon,bottle,fire,alchemist,molotov',
      icon: (
        <GiFireBottle
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fire silhouette',
      tag: 'all,fire,element,shadow,silhouette,flame',
      icon: (
        <GiFireSilhouette
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Wind',
      tag: 'all,wind,element, nature, force, air, tornado, tempest,',
      icon: (
        <GiWhirlwind
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sparkles',
      tag: 'all,magic, sparkle, light, effect',
      icon: (
        <GiSparkles
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Spectre',
      tag: 'all,spirit, ghost, spectre, magic',
      icon: (
        <GiSpectre
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Snowfall',
      tag: 'all,weather,snow, winter, storm',
      icon: (
        <GiSnowing
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Snowflake',
      tag: 'all,weather,snowflake,winter,cold',
      icon: (
        <GiSnowflake2
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fast backward',
      tag: 'all,media,control,rewind,backward',
      icon: (
        <GiFastBackwardButton
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fast forward',
      tag: 'all,media,control,forward',
      icon: (
        <GiFastForwardButton
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Water',
      tag: 'all,water,element, nature, force, wet, drop,',
      icon: (
        <GiWaterSplash
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Earth',
      tag: 'all,earthelement, nature, force,stone,rock,',
      icon: (
        <GiRock
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fluffy cloud',
      tag: 'all,weather,cloud,sky,soft',
      icon: (
        <GiFluffyCloud
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fluffy trefoil',
      tag: 'all,plant,trefoil,clover,leaf',
      icon: (
        <GiFluffyTrefoil
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Lightning',
      tag: 'all,lightning,element,nature,force,tempest,thunderstorm,',
      icon: (
        <GiPowerLightning
          size={size}
          color={color}
        />
      ),
    },

    { full: true },
    {
      label: 'Gems',
      tag: 'all,gems,precious,stone,nature,fortune,',
      icon: (
        <GiGems
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gem',
      tag: 'all,gem,precious,stone,nature,fortune,',
      icon: (
        <GiTopaz
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cut gem',
      tag: 'all,cut gem,precious,stone,fortune,',
      icon: (
        <GiAmethyst
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Diamond',
      tag: 'all,diamond,precious,stone,nature,fortune,',
      icon: (
        <GiCutDiamond
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Money',
      tag: 'all,money,precious, stack, bank, ticket, fortune,',
      icon: (
        <GiMoneyStack
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Coins',
      tag: 'all,money,precious, coins, gold, fortune,',
      icon: (
        <GiTwoCoins
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Pegasus',
      tag: 'all,pegasus,emblem,badge,symbol,animal,horse,fly,wing,mythology,',
      icon: (
        <GiPegasus
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hawk Emblem',
      tag: 'all,hawk, emblem, badge, symbol, animal, fly, wing, bird,',
      icon: (
        <GiHawkEmblem
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Werewolf',
      tag: 'all,werewolf,emblem,badge,symbol,wolf,animal,monster,',
      icon: (
        <GiWerewolf
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Arrows',
      tag: 'all,arrows,emblem,badge,symbol,target,weapon,',
      icon: (
        <GiTargetArrows
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Swords',
      tag: 'all,swords,emblem,badge,symbol,weapon,',
      icon: (
        <GiSwordsEmblem
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gear hammer',
      tag: 'all,gear,hammer,emblem,badge,symbol,craft,tool,',
      icon: (
        <GiGearHammer
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Caduceus',
      tag: 'all,caduceus,emblem,badge,symbol,medicine,heal,',
      icon: (
        <GiCaduceus
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Animals',
      tag: 'all,animals,emblem,badge,symbol,ouroboros,nature,animal,',
      icon: (
        <GiPlantsAndAnimals
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Paw print',
      tag: 'all,animal,emblem,badge,symbol,paw,nature,',
      icon: (
        <GiFlatPawPrint
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pentacle',
      tag: 'all,pentacle,emblem,badge,symbol,devil,witch,',
      icon: (
        <GiPentacle
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Third eye',
      tag: 'all,third eye,emblem,badge,symbol,mystic,',
      icon: (
        <GiWarlockEye
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cyber eye',
      tag: 'all,technology,cyber,eye,vision,scan,security',
      icon: (
        <GiCyberEye
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Circuit',
      tag: 'all,sci-fi,science fiction,circuit,electronic,chip,technology,',
      icon: (
        <GiCircuitry
          size={size}
          color={color}
        />
      ),
    },

    {
      label: 'Revolt',
      tag: 'all,revolt,emblem, badge, symbol,hand,',
      icon: (
        <GiRevolt
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Anarchy',
      tag: 'all,revolt,emblem, badge, symbol,anarchy,',
      icon: (
        <GiAnarchy
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dagger rose',
      tag: 'all,emblem, badge, symbol,dagger,rose,plant,nature,weapon,',
      icon: (
        <GiDaggerRose
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Shut rose',
      tag: 'all,emblem,badge,rose,closed,plant',
      icon: (
        <GiShutRose
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dagger gun',
      tag: 'all,emblem, badge, symbol,gun,rose,weapon,',
      icon: (
        <GiGunRose
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dream catcher',
      tag: 'all,emblem, badge, symbol,dream,catcher,',
      icon: (
        <GiDreamCatcher
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Achievement',
      tag: 'all,emblem, badge, symbol,medal,achievement,',
      icon: (
        <GiAchievement
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Allied star',
      tag: 'all,emblem,badge,symbol,star,medal,',
      icon: (
        <GiAlliedStar
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Seven pointed star',
      tag: 'all,emblem,badge,star,seven',
      icon: (
        <GiSevenPointedStar
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Materials science',
      tag: 'all,emblem,badge,symbol,science,atom,cube,',
      icon: (
        <GiMaterialsScience
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Book',
      tag: 'all,book,library,knowledge,',
      icon: (
        <GiWhiteBook
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Book aura',
      tag: 'all,book,library,knowledge,magic,aura,',
      icon: (
        <GiBookAura
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Book cover',
      tag: 'all,book,library,knowledge,',
      icon: (
        <GiBookCover
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Open book',
      tag: 'all,book,library,knowledge,',
      icon: (
        <GiOpenBook
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Books',
      tag: 'all,book,library,knowledge,',
      icon: (
        <GiBookshelf
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Open folder',
      tag: 'all,book,library,folder,organisation,knowledge,',
      icon: (
        <GiOpenFolder
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Notebook',
      tag: 'all,book,library,knowledge,notebook,note,',
      icon: (
        <GiNotebook
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Note stabbed',
      tag: 'all,book,library,knowledge,note,',
      icon: (
        <GiStabbedNote
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Parchment',
      tag: 'all,parchment,library,knowledge,roll,',
      icon: (
        <GiTiedScroll
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Diploma',
      tag: 'all,diploma,certificate,knowledge,school',
      icon: (
        <GiDiploma
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pencil',
      tag: 'all,pencil, writing, note, edit,object,',
      icon: (
        <GiPencil
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pencil brush',
      tag: 'all,pencil, writing, note, edit,object,',
      icon: (
        <GiPencilBrush
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Quill',
      tag: 'all,pencil, writing, note, edit, quill,object,',
      icon: (
        <GiQuillInk
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Electrocuted',
      tag: 'all,state,electrocuted,alteration,injury,skull,',
      icon: (
        <GiThunderSkull
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Poison',
      tag: 'all,state,poison,alteration,injury,skull,',
      icon: (
        <GiDeathJuice
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Burn',
      tag: 'all,state,burn,alteration,injury,skull,',
      icon: (
        <GiBurningSkull
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cursed',
      tag: 'all,state,cursed,alteration,injury,skull,',
      icon: (
        <GiTentaclesSkull
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crowned skull',
      tag: 'all,state,skull,crown,royal',
      icon: (
        <GiCrownedSkull
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Skull crack',
      tag: 'all,state,skull,crack,injury',
      icon: (
        <GiSkullCrack
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ghost',
      tag: 'all,spirit,ghost,undead,ethereal',
      icon: (
        <GiGhost
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'DNA strand',
      tag: 'all,state,science,dna,gene,helix',
      icon: (
        <GiDna1
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'DNA double',
      tag: 'all,state,science,dna,double,helix',
      icon: (
        <GiDna2
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heal',
      tag: 'all,state,heal,medecine,',
      icon: (
        <GiMedicalPackAlt
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Health potion',
      tag: 'all,state,heal,potion,medecine',
      icon: (
        <GiHealthPotion
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Health decrease',
      tag: 'all,state,health,decrease,down',
      icon: (
        <GiHealthDecrease
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Health increase',
      tag: 'all,state,health,increase,up',
      icon: (
        <GiHealthIncrease
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Health normal',
      tag: 'all,state,health,normal,steady',
      icon: (
        <GiHealthNormal
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hourglass',
      tag: 'all,time,hourglass,wait,delay',
      icon: (
        <GiHourglass
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Extra time',
      tag: 'all,time,bonus,extra',
      icon: (
        <GiExtraTime
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sands of time',
      tag: 'all,time,sand,hourglass',
      icon: (
        <GiSandsOfTime
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Time dynamite',
      tag: 'all,time,dynamite,bomb,timer',
      icon: (
        <GiTimeDynamite
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Healing shield',
      tag: 'all,state,heal,shield, weapon,medecine,',
      icon: (
        <GiHealingShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Healing',
      tag: 'all,state,heal,silhouette,medecine',
      icon: (
        <GiHealing
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart beats',
      tag: 'all,state,heart,life, beats,',
      icon: (
        <GiHeartBeats
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart drop',
      tag: 'all,state,heart,life, drop,',
      icon: (
        <GiHeartDrop
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Sight disabled',
      tag: 'all,state,blind,sight,disabled',
      icon: (
        <GiSightDisabled
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart bottle',
      tag: 'all,state,heart,potion,bottle',
      icon: (
        <GiHeartBottle
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Glass heart',
      tag: 'all,state,heart,life, half,',
      icon: (
        <GiGlassHeart
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Half heart',
      tag: 'all,state,heart,life, half,',
      icon: (
        <GiHalfHeart
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Shattered heart',
      tag: 'all,state,heart,shattered,broken',
      icon: (
        <GiShatteredHeart
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart minus',
      tag: 'all,state,heart,life,minus',
      icon: (
        <GiHeartMinus
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart plus',
      tag: 'all,state,heart,life,plus',
      icon: (
        <GiHeartPlus
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart shield',
      tag: 'all,state,heart,defense,shield',
      icon: (
        <GiHeartShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Heart wings',
      tag: 'all,state,heart,wings,freedom',
      icon: (
        <GiHeartWings
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Crowned heart',
      tag: 'all,state,heart,crown,royal',
      icon: (
        <GiCrownedHeart
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'House',
      tag: 'all,home,place,house,',
      icon: (
        <GiHouse
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Camp',
      tag: 'all,camp,place,tent,',
      icon: (
        <GiCampingTent
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Village',
      tag: 'all,village,place,building,houses,',
      icon: (
        <GiVillage
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'City',
      tag: 'all,city,place,building,houses,',
      icon: (
        <GiModernCity
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Church',
      tag: 'all,church,place,building,',
      icon: (
        <GiChurch
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Castle',
      tag: 'all,castle,place,building,',
      icon: (
        <GiCastle
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dolmen',
      tag: 'all,dolmen,place,rock,ancient,',
      icon: (
        <GiDolmen
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Coliseum',
      tag: 'all,coliseum,roman,ruin,place,building,',
      icon: (
        <GiColiseum
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ruin',
      tag: 'all,ruin,place,building,',
      icon: (
        <GiAncientRuins
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pyramid',
      tag: 'all,pyramid,place,building,',
      icon: (
        <GiGreatPyramid
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Greek temple',
      tag: 'all,temple,greek,place,building,',
      icon: (
        <GiGreekTemple
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Temple',
      tag: 'all,temple,pyramid,place,building,',
      icon: (
        <GiByzantinTemple
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dungeon gate',
      tag: 'all,dungeon,gate,place,building,',
      icon: (
        <GiDungeonGate
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'World',
      tag: 'all,world,planet,earth,place,',
      icon: (
        <GiEarthAmerica
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Excalibur',
      tag: 'all,excalibur, sword,rock,weapon,mystic,',
      icon: (
        <GiAncientSword
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Tower',
      tag: 'all,tower,building,place,castle,',
      icon: (
        <GiWhiteTower
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hut',
      tag: 'all,hut,building,place,home,',
      icon: (
        <GiHut
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Factory',
      tag: 'all,factory,building,place,',
      icon: (
        <GiFactory
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Mountain',
      tag: 'all,mountain,place,nature,landscape,',
      icon: (
        <GiPeaks
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Plains',
      tag: 'all,plains,place,nature,landscape,grass,vegetal,',
      icon: (
        <GiHighGrass
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hills',
      tag: 'all,plains,place,nature,landscape,grass,vegetal,hills,',
      icon: (
        <GiHills
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Forest',
      tag: 'all,forest,place,nature,landscape,wood,trees,',
      icon: (
        <GiForest
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Swamp',
      tag: 'all,swamp,place,nature,landscape,mist,water,puddle,reed,',
      icon: (
        <GiSwamp
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Island',
      tag: 'all,island,place,nature,landscape,palm,sand,beach,',
      icon: (
        <GiIsland
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Desert',
      tag: 'all,sand,sun,nature,hot,desert,place,landscape,',
      icon: (
        <GiDesert
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Canyon',
      tag: 'all,canyon,nature,landscape,place,desert,sand,rock,sun,hot,',
      icon: (
        <GiMonumentValley
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fossil',
      tag: 'all,nature,fossil,bone,dinosaur,ancient',
      icon: (
        <GiFossil
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Footprint',
      tag: 'all,track,footprint,trail,animal',
      icon: (
        <GiFootprint
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cave',
      tag: 'all,cave,place,nature,landscape,mountain,shadow,',
      icon: (
        <GiCaveEntrance
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Volcano',
      tag: 'all,volcano,place,nature,landscape,mountain,hot,lava,danger,',
      icon: (
        <GiVolcano
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Wave',
      tag: 'all,wave,place,nature,landscape,sea,ocean,water,storm,',
      icon: (
        <GiBigWave
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cold',
      tag: 'all,cold,place,nature,snow,temperature,degree,thermometer,',
      icon: (
        <GiThermometerCold
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hot',
      tag: 'all,hot,place,nature,sun,temperature,degree,thermometer,',
      icon: (
        <GiThermometerHot
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Moon',
      tag: 'all,moon,astre,nature,night, dark,',
      icon: (
        <GiMoon
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Moon orbit',
      tag: 'all,moon,orbit,planet,space,',
      icon: (
        <GiMoonOrbit
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ringed planet',
      tag: 'all,sci-fi,science fiction,planet,ringed,space,orbit,nature,',
      icon: (
        <GiRingedPlanet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Atom',
      tag: 'all,sci-fi,science fiction,atom,nuclear,science,nature,',
      icon: (
        <GiAtom
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Pawn',
      tag: 'all,pawn,meeple,',
      icon: (
        <Gi3DMeeple
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Mask',
      tag: 'all,mask, face, head, cloth, hide',
      icon: (
        <GiArchitectMask
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Ornate mask',
      tag: 'all,mask, face, head, cloth, hide',
      icon: (
        <GiCurlyMask
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Double mask',
      tag: 'all,mask, face, head, cloth, hide',
      icon: (
        <GiDoubleFaceMask
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cyborg face',
      tag: 'all,sci-fi,science fiction,technology,cyborg,robot,android,cyber,face,head,',
      icon: (
        <GiCyborgFace
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Alien skull',
      tag: 'all,sci-fi,science fiction,alien,space,monster,skull,',
      icon: (
        <GiAlienSkull
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Swordman',
      tag: 'all,people,sword,weapon,shield,action,movement,',
      icon: (
        <GiSwordman
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Acrobat',
      tag: 'all,people,acrobat,action,movement,',
      icon: (
        <GiAcrobatic
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Acrobat2',
      tag: 'all,people,acrobat,action,movement,',
      icon: (
        <GiBodyBalance
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hooded',
      tag: 'all,people,hooded,action,movement,run,',
      icon: (
        <GiHoodedFigure
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Jump',
      tag: 'all,people,jump,action,movement,',
      icon: (
        <GiRunningNinja
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Kick',
      tag: 'all,people,kick,action,movement,',
      icon: (
        <GiHighKick
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Person',
      tag: 'all,people,person,still,user,character,',
      icon: (
        <GiPerson
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Group',
      tag: 'all,people,character,person,user,group,',
      icon: (
        <GiThreeFriends
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hand',
      tag: 'all,people,hand,main,gesture,',
      icon: (
        <GiHand
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Fist',
      tag: 'all,people,hand,main,fist,combat,',
      icon: (
        <GiHandGrip
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Handshake',
      tag: 'all,people,hand,main,handshake,deal,agreement,team,',
      icon: (
        <GiShakingHands
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hand OK',
      tag: 'all,people,hand,main,ok,gesture,',
      icon: (
        <GiHandOk
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Glowing hands',
      tag: 'all,people,hand,main,magic,heal,energy,',
      icon: (
        <GiGlowingHands
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Grim reaper',
      tag: 'all,people,character,person,grim,reaper, death,',
      icon: (
        <GiGrimReaper
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Key',
      tag: 'all,key,locked,object,',
      icon: (
        <GiKeyring
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Padlock',
      tag: 'all,key,padlock,locked,object,',
      icon: (
        <GiPadlock
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Padlock open',
      tag: 'all,key,padlock,open,locked,object,',
      icon: (
        <GiPadlockOpen
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Magnifying glass',
      tag: 'all,magnifying, glass ,search,object,',
      icon: (
        <GiMagnifyingGlass
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Notification',
      tag: 'all,ui,notification,bell,alert,',
      icon: (
        <GiRingingBell
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Bookmark',
      tag: 'all,ui,bookmark,favorite,pin,save,',
      icon: (
        <GiBookmark
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Pin',
      tag: 'all,pin,object,',
      icon: (
        <GiPin
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Gift',
      tag: 'all,gift,present,object,',
      icon: (
        <GiPresent
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Position marker',
      tag: 'all,position,marker,map,object,',
      icon: (
        <GiPositionMarker
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Clef',
      tag: 'all,clef,music,symbol,',
      icon: (
        <GiGClef
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Music notes',
      tag: 'all,music,musique,note,notes,instrument,sound,audio,',
      icon: (
        <GiMusicalNotes
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Guitar',
      tag: 'all,music,musique,instrument,guitar,guitare,string,',
      icon: (
        <GiGuitar
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Piano',
      tag: 'all,music,musique,instrument,piano,keyboard,clavier,',
      icon: (
        <GiGrandPiano
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Violin',
      tag: 'all,music,musique,instrument,violin,violon,string,',
      icon: (
        <GiViolin
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Drum',
      tag: 'all,music,musique,instrument,drum,battery,batterie,percussion,',
      icon: (
        <GiDrumKit
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Trumpet',
      tag: 'all,music,musique,instrument,trumpet,trompette,brass,',
      icon: (
        <GiTrumpet
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Saxophone',
      tag: 'all,music,musique,instrument,saxophone,sax,jazz,',
      icon: (
        <GiSaxophone
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Flute',
      tag: 'all,music,musique,instrument,flute,woodwind,',
      icon: (
        <GiFlute
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Film strip',
      tag: 'all,film,strip,movie,cinema,object,',
      icon: (
        <GiFilmStrip
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Direction',
      tag: 'all,direction,sign,object,',
      icon: (
        <GiDirectionSigns
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Hanging sign',
      tag: 'all,sign,shop,hanging,banner',
      icon: (
        <GiHangingSign
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Digital trace',
      tag: 'all,technology,digital,fingerprint,trace',
      icon: (
        <GiDigitalTrace
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Nano bot',
      tag: 'all,technology,robot,nano,bot,cyber,ai',
      icon: (
        <GiNanoBot
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Settings knobs',
      tag: 'all,ui,settings,knobs',
      icon: (
        <GiSettingsKnobs
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Help',
      tag: 'all,ui,help,question,info',
      icon: (
        <GiHelp
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cancel',
      tag: 'all,ui,cancel,close,cross',
      icon: (
        <GiCancel
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Flying flag',
      tag: 'all,flag,banner,wind,symbol',
      icon: (
        <GiFlyingFlag
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Database',
      tag: 'all,data,base,object,',
      icon: (
        <GiDatabase
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Tag',
      tag: 'all,tag,label,category,filter,',
      icon: (
        <GiPriceTag
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Folder',
      tag: 'all,folder,directory,container,object,',
      icon: (
        <GiFullFolder
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Upgrade',
      tag: 'all,ui,upgrade,level,up,arrow,improve,',
      icon: (
        <GiUpgrade
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Link',
      tag: 'all,link,round,ring,object,',
      icon: (
        <GiLinkedRings
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Share',
      tag: 'all,share,link,network,send,',
      icon: (
        <GiShare
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Megaphone',
      tag: 'all,megaphone,loud,acoustic,object,',
      icon: (
        <GiAcousticMegaphone
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Alarm clock',
      tag: 'all,alarm,clock,object,',
      icon: (
        <GiAlarmClock
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Globe',
      tag: 'all,globe,map, world,object,',
      icon: (
        <GiGlobe
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cloud upload',
      tag: 'all,cloud,upload,arrow,storage,',
      icon: (
        <GiCloudUpload
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Cloud download',
      tag: 'all,cloud,download,arrow,storage,',
      icon: (
        <GiCloudDownload
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Trash',
      tag: 'all,trash,delete,remove,bin,',
      icon: (
        <GiTrashCan
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Dice six',
      tag: 'all,dice,six, game,object,',
      icon: (
        <GiDiceSixFacesOne
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice six (6)',
      tag: 'all,dice,d6,six,6,game,object,',
      icon: (
        <GiDiceSixFacesSix
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice eight',
      tag: 'all,dice,eight, game,object,',
      icon: (
        <GiDiceEightFacesEight
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice twenty',
      tag: 'all,dice,twenty, game,object,',
      icon: (
        <GiDiceTwentyFacesOne
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'D4',
      tag: 'all,dice,d4,tetrahedron,tabletop,rpg,game,object,',
      icon: (
        <GiD4
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'D10',
      tag: 'all,dice,d10,tabletop,rpg,game,object,',
      icon: (
        <GiD10
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'D12',
      tag: 'all,dice,d12,tabletop,rpg,game,object,',
      icon: (
        <GiD12
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice twenty (20)',
      tag: 'all,dice,d20,twenty,20,critical,crit,game,object,',
      icon: (
        <GiDiceTwentyFacesTwenty
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice shield',
      tag: 'all,dice,shield,game,object',
      icon: (
        <GiDiceShield
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice fire',
      tag: 'all,dice,fire,game,object',
      icon: (
        <GiDiceFire
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice target',
      tag: 'all,dice,target,game,object',
      icon: (
        <GiDiceTarget
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Rolling dices',
      tag: 'all,dice,rolling,roll,game,object,',
      icon: (
        <GiRollingDices
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Rolling dice cup',
      tag: 'all,dice,cup,rolling,roll,game,object,',
      icon: (
        <GiRollingDiceCup
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Dice random',
      tag: 'all,dice,random,roll,luck,game,object,',
      icon: (
        <GiPerspectiveDiceSixFacesRandom
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Playing card',
      tag: 'all,game,card,carte,playing card,poker,spade,',
      icon: (
        <GiCardAceSpades
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Playing card heart',
      tag: 'all,game,card,carte,playing card,poker,heart,',
      icon: (
        <GiCardKingHearts
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Poker hand',
      tag: 'all,game,card,carte,poker,hand,',
      icon: (
        <GiPokerHand
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Board',
      tag: 'all,game,board,plateau,chess,grid,',
      icon: (
        <GiEmptyChessboard
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Chess pawn',
      tag: 'all,game,chess,pawn,pion,board,',
      icon: (
        <GiChessPawn
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Meeple',
      tag: 'all,game,meeple,pion,pawn,boardgame,',
      icon: (
        <GiMeeple
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Token',
      tag: 'all,game,token,jeton,marker,boardgame,',
      icon: (
        <GiToken
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Domino',
      tag: 'all,game,domino,tiles,tile,boardgame,',
      icon: (
        <GiDominoTiles
          size={size}
          color={color}
        />
      ),
    },
    { full: true },
    {
      label: 'Abstract 001',
      tag: 'all,abstract',
      icon: (
        <GiAbstract001
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 002',
      tag: 'all,abstract, circle',
      icon: (
        <GiAbstract002
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 003',
      tag: 'all,abstract',
      icon: (
        <GiAbstract003
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 005',
      tag: 'all,abstract',
      icon: (
        <GiAbstract005
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 007',
      tag: 'all,abstract, flower',
      icon: (
        <GiAbstract007
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 008',
      tag: 'all,abstract',
      icon: (
        <GiAbstract008
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 009',
      tag: 'all,abstract',
      icon: (
        <GiAbstract009
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 010',
      tag: 'all,abstract',
      icon: (
        <GiAbstract010
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 011',
      tag: 'all,abstract',
      icon: (
        <GiAbstract011
          size={size}
          color={color}
        />
      ),
    },

    {
      label: 'Abstract 012',
      tag: 'all,abstract',
      icon: (
        <GiAbstract012
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 013',
      tag: 'all,abstract',
      icon: (
        <GiAbstract013
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 014',
      tag: 'all,abstract',
      icon: (
        <GiAbstract014
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 016',
      tag: 'all,abstract',
      icon: (
        <GiAbstract016
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 017',
      tag: 'all,abstract',
      icon: (
        <GiAbstract017
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 018',
      tag: 'all,abstract',
      icon: (
        <GiAbstract018
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 019',
      tag: 'all,abstract',
      icon: (
        <GiAbstract019
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 020',
      tag: 'all,abstract',
      icon: (
        <GiAbstract020
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 021',
      tag: 'all,abstract',
      icon: (
        <GiAbstract021
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 022',
      tag: 'all,abstract',
      icon: (
        <GiAbstract022
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 023',
      tag: 'all,abstract',
      icon: (
        <GiAbstract023
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 024',
      tag: 'all,abstract',
      icon: (
        <GiAbstract024
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 025',
      tag: 'all,abstract',
      icon: (
        <GiAbstract025
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 026',
      tag: 'all,abstract',
      icon: (
        <GiAbstract026
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 027',
      tag: 'all,abstract',
      icon: (
        <GiAbstract027
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 028',
      tag: 'all,abstract',
      icon: (
        <GiAbstract028
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 029',
      tag: 'all,abstract',
      icon: (
        <GiAbstract029
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 030',
      tag: 'all,abstract',
      icon: (
        <GiAbstract030
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 031',
      tag: 'all,abstract',
      icon: (
        <GiAbstract031
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 032',
      tag: 'all,abstract',
      icon: (
        <GiAbstract032
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 033',
      tag: 'all,abstract',
      icon: (
        <GiAbstract033
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 034',
      tag: 'all,abstract',
      icon: (
        <GiAbstract034
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 035',
      tag: 'all,abstract',
      icon: (
        <GiAbstract035
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 036',
      tag: 'all,abstract',
      icon: (
        <GiAbstract036
          size={size}
          color={color}
        />
      ),
    },
    {
      label: 'Abstract 037',
      tag: 'all, abstract',
      icon: (
        <GiAbstract037
          size={size}
          color={color}
        />
      ),
    },
  ];
  return icons.map(icon => ({
    ...icon,
    slug: icon.slug ?? slugifyIconLabel(icon.label),
  }));
};

const iconBlueprints = buildRawIconList();

const iconDefinitions = iconBlueprints.map(iconEntry => {
  const { icon, tag = '', ...meta } = iconEntry;
  const tags = tag
    ? tag
        .split(',')
        .map(value => value.trim().toLowerCase())
        .filter(Boolean)
    : [];
  return {
    ...meta,
    tag,
    tags,
    Component: icon ? icon.type : null,
  };
});

const iconMetadata = iconDefinitions.map(({ Component, ...meta }) => ({
  ...meta,
}));

const iconBySlug = new Map();
const iconByLabel = new Map();

iconDefinitions.forEach(entry => {
  if (entry.slug) {
    iconBySlug.set(entry.slug, entry);
  }
  if (entry.label) {
    iconByLabel.set(entry.label.toLowerCase(), entry);
  }
});

const renderedIconCache = new Map();
const iconListCache = new Map();

const getIconScale = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 1;
  }
  return window.matchMedia('(max-width: 768px)').matches ? 1.2 : 1;
};

const scaleIconSize = size => {
  if (!Number.isFinite(size)) {
    return size;
  }
  const scale = getIconScale();
  if (scale === 1) {
    return size;
  }
  return Math.max(1, Math.round(size * scale));
};

const getRenderKey = (slug, size, color) =>
  `${slug ?? 'unknown'}|${size ?? ''}|${color ?? ''}|${getIconScale()}`;

const renderIconFromEntry = (entry, size, color) => {
  if (!entry?.Component) {
    return null;
  }
  const cacheKey = getRenderKey(entry.slug, size, color);
  if (renderedIconCache.has(cacheKey)) {
    return renderedIconCache.get(cacheKey);
  }
  const Component = entry.Component;
  const scaledSize = scaleIconSize(size);
  const className = Number.isFinite(size) ? 'app-icon--sized' : undefined;
  const element = Component ? (
    <Component
      size={scaledSize}
      color={color}
      className={className}
    />
  ) : null;
  renderedIconCache.set(cacheKey, element);
  return element;
};

export const getIconMetadata = () => iconMetadata;

export const searchIcons = (query = '') => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return iconMetadata;
  }
  return iconMetadata.filter(meta => {
    if (meta.label?.toLowerCase().includes(normalized)) {
      return true;
    }
    if (meta.slug?.includes(normalized)) {
      return true;
    }
    if (meta.tag?.toLowerCase().includes(normalized)) {
      return true;
    }
    return meta.tags?.some(tag => tag.startsWith(normalized));
  });
};

export const renderIconBySlug = (slug, { size, color } = {}) => {
  if (!slug) {
    return null;
  }
  const entry = iconBySlug.get(slug);
  return entry ? renderIconFromEntry(entry, size, color) : null;
};

export const renderIconByLabel = (label, { size, color } = {}) => {
  if (!label) {
    return null;
  }
  const entry = iconByLabel.get(label.toLowerCase());
  return entry ? renderIconFromEntry(entry, size, color) : null;
};

export const IconsList = (size, color) => {
  const cacheKey = getRenderKey('list', size, color);
  if (iconListCache.has(cacheKey)) {
    return iconListCache.get(cacheKey);
  }
  const list = iconDefinitions.map(entry => ({
    label: entry.label,
    tag: entry.tag,
    tags: entry.tags,
    slug: entry.slug,
    icon: renderIconFromEntry(entry, size, color),
  }));
  iconListCache.set(cacheKey, list);
  return list;
};
